// src/pages/Shop.tsx
import React, { useState, useEffect } from 'react'
import api from '../api/axios'
import './Shop.css'
import bgImg          from '../assets/shop/bg.png'
import boxImg         from '../assets/shop/box.png'
import tabBtnImg      from '../assets/shop/button.png'
import placeholderImg from '../assets/shop/placeholder.png'

type ShopItem = {
  key: string
  displayName: string
  price: number
  currency: 'silver' | 'gold'
  description: string
}
type ToolItem = {
  key: string
  displayName: string
  cost: number
}

export default function ShopPage() {
  const [shopItems, setShopItems] = useState<ShopItem[]|null>(null)
  const [tools, setTools]         = useState<ToolItem[]|null>(null)
  const [error, setError]         = useState<string|null>(null)
  const [activeTab, setActiveTab] = useState<'shop'|'tools'>('shop')

  useEffect(() => {
    Promise.all([
      api.get<ShopItem[]>('/shop'),
      api.get<ToolItem[]>('/buytool'),
    ])
      .then(([shopRes, toolsRes]) => {
        setShopItems(shopRes.data)
        setTools(toolsRes.data)
      })
      .catch(e => {
        console.error(e)
        setError(e.response?.data?.error || e.message)
      })
  }, [])

  const buy = (path: string, key: string) => {
    api.post(path, path === '/shop/buy' ? { item: key } : { tool: key })
      .then(() => alert('Purchased!'))
      .catch(e => alert(e.response?.data?.error || e.message))
  }

  const loading = shopItems === null || tools === null

  const imgFor = (key: string) => {
    try {
      return require(`../assets/shop/${key}.png`)
    } catch {
      return placeholderImg
    }
  }

  return (
    <div className="shop-page" style={{ backgroundImage: `url(${bgImg})` }}>
      <div className="shop-container" style={{ backgroundImage: `url(${boxImg})` }}>

        {loading ? (
          <p className="loading">Loading shop…</p>
        ) : error ? (
          <p className="shop-error">{error}</p>
        ) : (
          <>
            <div className="tab-bar">
              <button
                className={`tab-btn${activeTab==='shop'? ' active':''}`}
                onClick={() => setActiveTab('shop')}
                style={{ backgroundImage: `url(${tabBtnImg})` }}
              >
                Shop
              </button>
              <button
                className={`tab-btn${activeTab==='tools'? ' active':''}`}
                onClick={() => setActiveTab('tools')}
                style={{ backgroundImage: `url(${tabBtnImg})` }}
              >
                Tools
              </button>
            </div>

            {activeTab === 'shop' ? (
              <table className="shop-table">
                <thead>
                  <tr>
                    <th></th>
                    <th align="left">Item</th>
                    <th>Price</th>
                    <th>Description</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {shopItems!.map(i => (
                    <tr key={i.key}>
                      <td>
                        <img
                          src={imgFor(i.key)}
                          alt={i.displayName}
                          className="shop-item-img"
                        />
                      </td>
                      <td>{i.displayName}</td>
                      <td>{i.price} {i.currency}</td>
                      <td>{i.description}</td>
                      <td>
                        <button
                          className="buy-btn"
                          style={{ backgroundImage: `url(${tabBtnImg})` }}
                          onClick={() => buy('/shop/buy', i.key)}
                        >
                          Buy
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <table className="shop-table">
                <thead>
                  <tr>
                    <th></th>
                    <th align="left">Tool</th>
                    <th>Cost (silver)</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {tools!.map(t => (
                    <tr key={t.key}>
                      <td>
                        <img
                          src={imgFor(t.key)}
                          alt={t.displayName}
                          className="shop-item-img"
                        />
                      </td>
                      <td>{t.displayName}</td>
                      <td>{t.cost}</td>
                      <td>
                        <button
                          className="buy-btn"
                          style={{ backgroundImage: `url(${tabBtnImg})` }}
                          onClick={() => buy('/buytool', t.key)}
                        >
                          Buy
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}

      </div>
    </div>
  )
}
